import { CallCalling } from 'iconsax-react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import home from '../../assets/images/home.svg';
import svgLocation from '../../assets/images/location.svg';
import money from '../../assets/images/money.svg';
import passport from '../../assets/images/passport.svg';
import Text from '../../assets/styles/Text';
import { useModelVerification } from '../../hooks/queries/useMediaUploads';
import calculateAge from '../../utils/calculateAge';
import preloadVerification from '../../utils/preloadVerification';
import Loader from '../Loader';
import * as styles from './styles';

export default function ModalModel({ model }) {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const {
    id,
    fantasyName,
    impactPhrase,
    dateOfBirth,
    values,
    phone,
    modelPlan,
    modelUpgrade,
    city,
    district,
    location,
  } = model;

  const {
    data: verificationData,
    isLoading,
    isError,
  } = useModelVerification(id);

  const verification = verificationData?.urls || {};

  useEffect(() => {
    async function preloadImages() {
      if (!verification?.profilePhoto && !verification?.bannerPhoto) {
        return;
      }

      try {
        const bannerUrl =
          verification?.bannerPhoto || verification?.profilePhoto;
        const profileUrl = verification?.profilePhoto;

        await preloadVerification([bannerUrl, profileUrl]);
        setImagesLoaded(true);
      } catch (error) {
        console.error('Erro ao preload de imagens:', error);
        setImagesLoaded(true);
      }
    }

    preloadImages();
  }, [verification]);

  const modelIs2 = modelPlan?.plan?.type === 2;
  const modelIs3 = modelPlan?.plan?.type === 3;
  const model2and3 = modelIs2 || modelIs3;

  const types = modelUpgrade?.map((item) => item.upgrade.type);

  const showLoading = isLoading || !imagesLoaded;

  // ✅ Placeholder de imagem em caso de erro
  const bannerImage = isError
    ? '/placeholder-banner.jpg' // Imagem padrão
    : verification?.bannerPhoto || verification?.profilePhoto;

  const profileImage = isError
    ? '/placeholder-profile.jpg' // Imagem padrão
    : verification?.profilePhoto;

  return (
    <styles.Container
      $bost={types?.includes(3)}
      $modelIs2={modelIs2}
      $modelIs3={modelIs3}
    >
      <Link to={`/model/${id}`}>
        <styles.Banner $banner={bannerImage} className="watermark">
          {showLoading && <Loader isLoading minimal size={40} />}
        </styles.Banner>

        <styles.GroupInfos>
          <styles.GroupImgDescription $margin={modelPlan?.plan?.type}>
            <styles.ImgDescription $img={profileImage}>
              {showLoading && <Loader isLoading minimal size={28} />}
            </styles.ImgDescription>

            {model2and3 && <Text.Span>{impactPhrase}</Text.Span>}
          </styles.GroupImgDescription>

          <styles.Infos>
            <Text.H4 $bold title={fantasyName}>
              {fantasyName}
            </Text.H4>

            <styles.GroupText $bost={types?.includes(3)}>
              <img src={money} alt="icon" />
              <Text.P $bold className="price">
                R$ {values?.[0]?.customRate} / {values?.[0]?.value?.name}
              </Text.P>
            </styles.GroupText>

            <styles.GroupText $bost={types?.includes(3)}>
              <img src={passport} alt="icon" className="bottom" />
              <Text.Span>{calculateAge(dateOfBirth)} anos</Text.Span>
            </styles.GroupText>

            {model2and3 && (
              <>
                <styles.GroupText $bost={types?.includes(3)}>
                  <img src={home} alt="icon" className="width" />
                  <Text.Span>{location ? 'Com Local' : 'Sem Local'}</Text.Span>
                </styles.GroupText>

                <styles.GroupText $bost={types?.includes(3)}>
                  <img src={svgLocation} alt="icon" className="location" />
                  <Text.Span>
                    {district
                      ? `${district} - ${city.name} - ${city.stateAc}`
                      : `${city.name} - ${city.stateAc}`}
                  </Text.Span>
                </styles.GroupText>
              </>
            )}
          </styles.Infos>
        </styles.GroupInfos>
      </Link>

      {modelIs3 && (
        <styles.GroupButton $bost={types?.includes(3)}>
          <a
            href={`https://wa.me/${phone?.replace(
              /\D/g,
              ''
            )}?text=${encodeURIComponent(
              `Olá, ${fantasyName}! Vi seu perfil no FlameHot e gostaria de conversar.`
            )}`}
            target="_blank"
            rel="noreferrer"
          >
            <CallCalling />
            <Text.H4>Telefone</Text.H4>
          </a>
        </styles.GroupButton>
      )}
    </styles.Container>
  );
}

ModalModel.propTypes = {
  model: PropTypes.shape().isRequired,
};
